export default __webpack_public_path__ + "static/media/accidental-death.13a0b6e8.svg";